import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/eb-garamond/400.css';
import '@fontsource/eb-garamond/400-italic.css';
import '@fontsource/eb-garamond/500.css';
import '@fontsource/rethink-sans/400.css';
import '@fontsource/rethink-sans/500.css';
import '@fontsource/rethink-sans/600.css';
import '@fontsource/rethink-sans/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import './design/colors.css';
import './design/palette.css';
import './design/spacing.css';
import './design/typography.css';
import './design/motion.css';
import './design/components.css';
import './design/base.css';
import { initTheme } from './design/theme';
import { App } from './App';

initTheme();

const root = document.getElementById('root');
if (!root) {
  throw new Error('Élément #root introuvable.');
}
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
